import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Header from "../components/header";
import { helmetRequest } from "../../app/state/actions";
import Helmet from "react-helmet";

import { doLoginRequest, doRegisterRequest } from "../state/actions";
import RecoverPassword from "../components/recoverPassword";

class Recover extends Component {
  componentDidMount() {
    const { helmetRequest, location } = this.props;

    helmetRequest({
      title: "Esqueci a senha",
      canonical: location.pathname
    });
  }

  render() {
    const { match, data } = this.props;

    return (
      <Fragment>
        <Helmet>
          <title>{data.helmet.title}</title>
          {/* <link rel="canonical" href={data.helmet.canonical} /> */}

          <meta property="og:type" content="website" />
          <meta property="og:title" content={data.helmet.title} />
          <meta property="og:image" content="https://www.aprovatotal.com.br/static/media/ogimage.png" />
          <meta property="og:site_name" content="Aprova Total" />
          <meta
            property="og:description"
            content="O Aprova Total é a Plataforma de Ciências da Natureza do Prof. Jubilut. Possuímos Cursos Online de Biologia, Química e Física para o ENEM e VESTIBULARES."
          />
          <meta property="og:url" content={data.helmet.canonical} />
          <meta property="fb:app_id" content="419544841446578" />
          <meta property="fb:admins" content="1161495405" />
        </Helmet>
        <Header showSubTitle="true" />
        <RecoverPassword match={match} />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state.account,
    ...state.app
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      doRegisterRequest,
      doLoginRequest,
      helmetRequest
    },
    dispatch
  );
};

const Routered = withRouter(connect(mapStateToProps, mapDispatchToProps)(Recover));

Routered.displayName = "Recover";

export default Routered;
